(function () {

  if (window.ProductInfoAudioLoaded) {
    return;
  }

  window.ProductInfoAudioLoaded = true;


  class ProductInfoAudio {

    constructor(container) {

      this.container = container;

      this.audio = container.querySelector(
        '[data-product-audio]'
      );

      this.button = container.querySelector(
        '[data-product-audio-button]'
      );

      this.icon = container.querySelector(
        '[data-product-audio-icon]'
      );

      this.text = container.querySelector(
        '[data-product-audio-text]'
      );

      this.progress = container.querySelector(
        '[data-product-audio-progress]'
      );

      this.currentTime = container.querySelector(
        '[data-product-audio-current]'
      );

      this.duration = container.querySelector(
        '[data-product-audio-duration]'
      );

      // Grab the scoped gradient ID from the audio element's
      // data-gradient-id attribute set in the Liquid snippet.
      this.gradientId =
        this.audio
          ? (this.audio.dataset.gradientId || 'speakerGradient')
          : 'speakerGradient';

      /*
       * Stop if required elements are missing.
       */
      if (!this.audio || !this.button) {
        console.warn(
          'Product Info Audio: Required elements not found.',
          container
        );
        return;
      }

      /*
       * Get default button text.
       */
      this.defaultText =
        this.button.dataset.defaultText || 'Listen Now';

      this.init();
    }


    /* =========================================================
       INITIALIZE
       ========================================================= */

    init() {

      this.button.addEventListener('click', () => {
        this.toggle();
        this.trackButtonPress();
      });

      /*
       * FIX: loadedmetadata fires as soon as the browser has read
       * the audio headers (duration etc.) from preload="metadata".
       * This means duration shows correctly on page load without
       * the user needing to click play first.
       */
      this.audio.addEventListener('loadedmetadata', () => {
        this.updateDuration();
      });

      /*
       * Audio progress
       */
      this.audio.addEventListener('timeupdate', () => {
        this.updateProgress();
      });

      /*
       * Audio started
       */
      this.audio.addEventListener('play', () => {
        this.setPauseState();
      });

      /*
       * Audio paused
       */
      this.audio.addEventListener('pause', () => {
        if (!this.audio.ended) {
          this.setPlayState();
        }
      });

      /*
       * Audio ended
       */
      this.audio.addEventListener('ended', () => {
        this.reset();
      });

      /*
       * Progress slider
       */
      if (this.progress) {
        this.progress.addEventListener('input', () => {
          this.seek();
        });
      }

      /*
       * FIX: If metadata is already available by the time JS runs
       * (e.g. cached audio or fast network), loadedmetadata won't
       * fire again — so we update duration immediately.
       */
      if (
        this.audio.readyState >= 1 &&
        this.audio.duration &&
        isFinite(this.audio.duration)
      ) {
        this.updateDuration();
      }

    }


    /* =========================================================
       TRACK BUTTON PRESS (Web Pixel custom event)
       ========================================================= */

    trackButtonPress() {

      if (
        typeof Shopify === 'undefined' ||
        !Shopify.analytics ||
        typeof Shopify.analytics.publish !== 'function'
      ) {
        return;
      }

      Shopify.analytics.publish('Roger Audio Button Event', {
        product_id:      this.container.dataset.productId,
        product_title:   this.container.dataset.productTitle,
        product_handle:  this.container.dataset.productHandle,
        product_url:     this.container.dataset.productUrl,
        button_text:     this.text
          ? this.text.textContent.trim()
          : this.defaultText,
        page_url:        window.location.href,
        customer_id:     this.container.dataset.customerId,
        customer_logged_in: this.container.dataset.customerId
          ? 'true'
          : 'false'
      });

    }


    /* =========================================================
       PLAY / PAUSE
       ========================================================= */

    toggle() {

      if (this.audio.paused) {

        this.pauseOtherPlayers();

        const playPromise = this.audio.play();

        if (playPromise !== undefined) {
          playPromise.catch((error) => {
            console.warn(
              'Product Info Audio could not be played:',
              error
            );
          });
        }

      } else {

        this.audio.pause();

      }

    }


    /* =========================================================
       PAUSE OTHER AUDIO PLAYERS
       ========================================================= */

    pauseOtherPlayers() {

      document
        .querySelectorAll('[data-product-audio]')
        .forEach((audio) => {
          if (audio !== this.audio) {
            audio.pause();
          }
        });

    }


    /* =========================================================
       PAUSE STATE — audio is playing, show pause UI
       ========================================================= */

    setPauseState() {

      this.button.setAttribute('aria-pressed', 'true');
      this.button.setAttribute('aria-label', 'Pause product information');

      if (this.text) {
        this.text.textContent = 'Pause';
      }

      if (this.icon) {
        this.icon.innerHTML = `
          <svg
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <rect x="6"  y="5" width="4" height="14" rx="1" fill="currentColor"/>
            <rect x="14" y="5" width="4" height="14" rx="1" fill="currentColor"/>
          </svg>
        `;
      }

    }


    /* =========================================================
       PLAY STATE — audio is paused, show play UI
       ========================================================= */

    setPlayState() {

      this.button.setAttribute('aria-pressed', 'false');
      this.button.setAttribute('aria-label', this.defaultText);

      if (this.text) {
        this.text.textContent = this.defaultText;
      }

      if (this.icon) {

        /*
         * FIX: Use the scoped gradientId read from data-gradient-id
         * so re-injected SVGs reference the correct per-block gradient.
         * Without this, multiple cards on the same page all point to
         * the same gradient ID and only the first one renders correctly.
         */
        const gId = this.gradientId;

        this.icon.innerHTML = `
          <svg
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient
                id="${gId}"
                x1="4" y1="5" x2="21" y2="19"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0%"   stop-color="#0098DA"/>
                <stop offset="100%" stop-color="#7B2CBF"/>
              </linearGradient>
            </defs>

            <path
              d="M4 9V15H8L13 19V5L8 9H4Z"
              fill="url(#${gId})"
            />
            <path
              d="M16 8.5C17.1 9.4 17.75 10.65 17.75 12C17.75 13.35 17.1 14.6 16 15.5"
              stroke="url(#${gId})"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M18.5 5.75C20.2 7.35 21.25 9.55 21.25 12C21.25 14.45 20.2 16.65 18.5 18.25"
              stroke="url(#${gId})"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        `;
      }

    }


    /* =========================================================
       UPDATE DURATION
       ========================================================= */

    updateDuration() {

      if (!this.audio.duration || !isFinite(this.audio.duration)) {
        return;
      }

      if (this.duration) {
        this.duration.textContent = this.formatTime(this.audio.duration);
      }

    }


    /* =========================================================
       UPDATE PROGRESS
       ========================================================= */

    updateProgress() {

      if (!this.audio.duration || !isFinite(this.audio.duration)) {
        return;
      }

      const percentage =
        (this.audio.currentTime / this.audio.duration) * 100;

      if (this.progress) {
        this.progress.value = percentage;
      }

      if (this.currentTime) {
        this.currentTime.textContent = this.formatTime(this.audio.currentTime);
      }

    }


    /* =========================================================
       SEEK
       ========================================================= */

    seek() {

      if (!this.audio.duration || !this.progress) {
        return;
      }

      this.audio.currentTime =
        this.audio.duration * (Number(this.progress.value) / 100);

    }


    /* =========================================================
       RESET
       ========================================================= */

    reset() {

      this.setPlayState();

      if (this.progress) {
        this.progress.value = 0;
      }

      if (this.currentTime) {
        this.currentTime.textContent = '0:00';
      }

    }


    /* =========================================================
       FORMAT TIME
       ========================================================= */

    formatTime(seconds) {

      if (!seconds || !isFinite(seconds)) {
        return '0:00';
      }

      const minutes         = Math.floor(seconds / 60);
      const remainingSeconds = Math.floor(seconds % 60);

      return minutes + ':' + String(remainingSeconds).padStart(2, '0');

    }

  }


  /* =========================================================
     INITIALIZATION
     ========================================================= */

  function initProductInfoAudio(root = document) {

    root.querySelectorAll('[data-product-info-audio]').forEach((container) => {

      if (container.dataset.audioInitialized === 'true') {
        return;
      }

      container.dataset.audioInitialized = 'true';

      new ProductInfoAudio(container);

    });

  }


  /* =========================================================
     DOM READY
     ========================================================= */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductInfoAudio());
  } else {
    initProductInfoAudio();
  }


  /* =========================================================
     SHOPIFY THEME EDITOR
     ========================================================= */

  document.addEventListener('shopify:section:load', (event) => {
    initProductInfoAudio(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    initProductInfoAudio(event.target);
  });

})();
